import {
  Container,
  Title,
  Text,
  Stack,
  Paper,
  Group,
  ThemeIcon,
} from '@mantine/core';
import { MessageCircle, Mail } from 'lucide-react';
import { useEffect } from 'react';

// Estendi l'interfaccia Window per includere tidioChatApi
declare global {
  interface Window {
    tidioChatApi?: {
      show: () => void;
      hide: () => void;
      open: () => void;
      close: () => void;
      display: (show: boolean) => void;
      on: (event: string, callback: () => void) => void;
    };
  }
}

export function Support() {
  useEffect(() => {
    // Carica lo script Tidio solo in questa pagina
    const script = document.createElement('script');
    script.src = '//code.tidio.co/135inlkppsi1crgj3lcxywv3bml5splk.js';
    script.async = true;
    document.body.appendChild(script);

    // Mostra il widget quando lo script è caricato
    script.onload = () => {
      if (window.tidioChatApi) {
        window.tidioChatApi.display(true);
        window.tidioChatApi.show();
      } else {
        // Se l'API non è ancora pronta, aspetta l'evento ready
        document.addEventListener('tidioChat-ready', () => {
          if (window.tidioChatApi) {
            window.tidioChatApi.display(true);
            window.tidioChatApi.show();
          }
        });
      }
    };

    // Cleanup: rimuovi lo script e nascondi il widget quando si lascia la pagina
    return () => {
      if (window.tidioChatApi) {
        window.tidioChatApi.hide();
        window.tidioChatApi.display(false);
      }
      script.remove();
    };
  }, []);

  const handleOpenChat = () => {
    if (window.tidioChatApi) {
      window.tidioChatApi.open();
    }
  };

  const handleOpenEmail = () => {
    window.location.href = 'mailto:support@become-hub.com';
  };

  return (
    <Container size='md' py='xl'>
      <Stack gap='xl'>
        <div>
          <Title order={1} mb='md'>
            Support
          </Title>
          <Text c='dimmed' size='lg'>
            Need help? We're here to assist you.
          </Text>
        </div>

        <Paper
          shadow='sm'
          p='xl'
          radius='md'
          withBorder
          style={{ cursor: 'pointer' }}
          onClick={handleOpenChat}
        >
          <Group>
            <ThemeIcon size='xl' radius='md' variant='light'>
              <MessageCircle size={24} />
            </ThemeIcon>
            <div>
              <Text fw={500} size='lg'>
                Live Chat
              </Text>
              <Text size='sm' c='dimmed'>
                Chat with our support team using the widget in the bottom right
                corner
              </Text>
            </div>
          </Group>
        </Paper>

        <Paper
          shadow='sm'
          p='xl'
          radius='md'
          withBorder
          style={{ cursor: 'pointer' }}
          onClick={handleOpenEmail}
        >
          <Group>
            <ThemeIcon size='xl' radius='md' variant='light'>
              <Mail size={24} />
            </ThemeIcon>
            <div>
              <Text fw={500} size='lg'>
                Email Support
              </Text>
              <Text size='sm' c='dimmed'>
                Send us an email and we'll get back to you within 24 hours
              </Text>
            </div>
          </Group>
        </Paper>
      </Stack>
    </Container>
  );
}
